<template>
    <div>
        <div class="dh_p1a w-100">
            <div class="x_div_center" style="height:100%; background-color:rgba(0, 0, 0, 0.3);">
                <div class="rp_set px-3" style="padding:120px 0 0 0;">
                    <span class="dh_p1b">M3 소개</span><br>
                    <span class="dh_p1c">ESG (Environmental, Social and Governance) 를 기업경영의 핵심으로 두고,<br>가격보다 고객 가치를
                        추구하며, 통합 BIM 및 DfMA 핵심 기술을 탑재한 자체 플랫폼으로,<br>보다 편리하고 빠르게 건축물을 구현합니다.</span>
                </div>
            </div>
        </div>

        <div class="x_div_center">
            <div class="rp_set" style="border:0px solid red">
                <!-- CEO PROLOGUE -->
                <div class="py-5">
                    <div class="x_div_left py-3">
                        <h2 class="fen-set3 fs-16" style="display: flex; align-items: center; gap: 10px;">
                            <span style="display: flex; flex-direction: column;">
                                <span style="width: 8px; height: 12px; background-color: #999; display: block;"></span>
                                <span style="width: 8px; height: 12px; background-color: #333; display: block;"></span>
                            </span>
                            <strong>CEO PROLOGUE</strong>
                        </h2>
                    </div>
                    <div v-if="!isMobileDevice" class="iw-1 py-2 d-flex"
                        style="align-items: center; gap: 40px; position: relative;">
                        <div class="iw-2 px-3" style="line-height: 175%; position: relative; z-index: 2;">
                            <p class="fkr-set2 fs-17" style="color: #7F1B27; line-height: 130%;"><strong>안녕하십니까.<br>M3
                                    시스템즈 입니다.</strong></p>
                            <p class="fkr-set2 fs-11 py-2">저는 1996년부터 한국에서 건축학과 교수로 재직했습니다.<br>여러 학회와 협회를 설립하고 건축분야의 디지털
                                트윈 기술인 BIM을 한국에 도입했고,<br>일찍이 AI와 BIM의 접목을 일생의 과제로 삼았습니다.</p>
                            <p class="fkr-set2 fs-11 py-2">오래된 산업인 건설 산업은 디지털 전환을 통해 제조화, 자동화, 첨단화 <br>되어야한다고
                                생각합니다.<br>공기지연, 부실공사, 비용증가라는 고질적인 문제에 이제는 인력부족, <br>안전사고 및 탄소배출 등의 문제까지 부각되어 파괴적 혁신이
                                요청됩니다.
                            </p>
                            <p class="fkr-set2 fs-11 py-2">때가 무르익었습니다. 수십년간 쌓은 지식과 경험을 본격적으로 펼치려 합니다.<br>누구나 빨리, 쉽게
                                만족스럽게 지을 수 있도록 설계, 제조, 시공, 유지관리의 전과정에서<br>수요자와 생산자 모두가 디저털 환경에서 투명하게 참여하는 <br>"DfMA 기반의
                                특화된
                                제조화건축 플랫폼"이 미래를 이끌 건축사업모델이 될 것입니다.</p>
                            <p class="fkr-set2 fs-11 py-2">빈틈 없이 설계되어 공장에서 안전하게 제작되고 현장에 옮겨져 순식간에 설치되는 <br>고품질 모듈러 건축물이
                                주변에
                                속속 들어설 것입니다.<br>그렇게 온통 뒤바뀔 미래가 눈앞에 열리고 있습니다.<br>미래 기술의 선두자로 M3 시스템즈는 꾸준히 성장해 나가겠습니다.</p>
                            <div class="py-4"
                                style="display: flex; align-items: center; justify-content: right; gap: 15px; margin-right: -150px;">
                                <span class="fkr-set1 fs-13">대 표 이 사</span>
                                <span class="fkr-set1 fs-20"><strong>김 인 한</strong></span>
                                <img src="@/assets/img/m3_introduce/ik_sign.png" width="170" style="margin-left: 10px;">
                            </div>
                        </div>
                        <div style="flex-shrink: 0; width: 40%; position: relative; z-index: 1;">
                            <img src="@/assets/img/m3_introduce/ik_profile.png" width="100%"
                                style="border-radius: 8px; object-fit: cover;">
                        </div>
                    </div>
                    <div v-else class="py-2">
                        <div class="px-3" style="line-height: 175%;">
                            <p class="fkr-set2 fs-17" style="color: #7F1B27; line-height: 130%;"><strong>안녕하십니까.<br>M3
                                    시스템즈 입니다.</strong></p>
                            <p class="fkr-set2 fs-11 py-2">저는 1996년부터 한국에서 건축학과 교수로 재직했습니다. 여러 학회와 협회를 설립하고 건축분야의 디지털
                                트윈 기술인 BIM을 한국에 도입했고, 일찍이 AI와 BIM의 접목을 일생의 과제로 삼았습니다.</p>
                            <p class="fkr-set2 fs-11 py-2">오래된 산업인 건설 산업은 디지털 전환을 통해 제조화, 자동화, 첨단화 되어야한다고
                                생각합니다. 공기지연, 부실공사, 비용증가라는 고질적인 문제에 이제는 인력부족, 안전사고 및 탄소배출 등의 문제까지 부각되어 파괴적 혁신이
                                요청됩니다.
                            </p>
                            <p class="fkr-set2 fs-11 py-2">때가 무르익었습니다. 수십년간 쌓은 지식과 경험을 본격적으로 펼치려 합니다. 누구나 빨리, 쉽게
                                만족스럽게 지을 수 있도록 설계, 제조, 시공, 유지관리의 전과정에서 수요자와 생산자 모두가 디저털 환경에서 투명하게 참여하는 "DfMA 기반의
                                특화된 제조화건축 플랫폼"이 미래를 이끌 건축사업모델이 될 것입니다.</p>
                            <p class="fkr-set2 fs-11 py-2">빈틈 없이 설계되어 공장에서 안전하게 제작되고 현장에 옮겨져 순식간에 설치되는 고품질 모듈러 건축물이
                                주변에 속속 들어설 것입니다. 그렇게 온통 뒤바뀔 미래가 눈앞에 열리고 있습니다. 미래 기술의 선두자로 M3 시스템즈는 꾸준히 성장해 나가겠습니다.</p>
                            <div class="text-center py-3"
                                style="display: flex; align-items: center; justify-content: center; gap: 10px;">
                                <span class="fkr-set1 fs-11">대 표 이 사</span>
                                <span class="fkr-set1 fs-16"><strong>김 인 한</strong></span>
                                <img src="@/assets/img/m3_introduce/ik_sign.png" width="100" style="margin-left: 5px;">
                            </div>
                        </div>
                    </div>
                </div>
                <!-- (주)엠쓰리시스템즈 -->
                <!-- <div class="iw-1 py-3 pt-5">
                    <div class="iw-2"><img src="@/assets/img/s_info/info1.png" width="100%"></div>
                    <div class="iw-4 px-4">
                        <div class="py-4"><img src="@/assets/img/s_info/s_info_logo.png" width="250"></div>
                        <div style="line-height:200%">
                            <p class="fkr-set2 fs-13 fc-w10"><strong>(주)엠쓰리시스템즈</strong>는</p>
                            <p class="fkr-set2 fs-09"><strong>Manufactured Modular via Meta-X Systems</strong> 입니다.</p>
                            <p class="fkr-set2 fs-09">첨단 BIM통합형 DfMA 기술을 보유한  모듈러건축 통합플랫폼 서비스 기업입니다.</p>
                            <p class="fkr-set2 fs-09">ESG(Environmental, Social and Governance)기업경영 윤리기반으로, 소중한 사람들과 함께하는 건축공간을 빠르고 정확하고 편리하게 제공합니다.</p>
                            <p class="fkr-set2 fs-09">연구진의 지난 20여년 간의 BIM 연구개발 경험 및 전문성으로 프리미엄 모듈러 건축물을 만드는 신뢰할 수 있는 기업으로 발전하겠습니다.</p>
                        </div>
                    </div>
                </div>
                <div style="height:50px"></div> -->
                <!-- (주)엠쓰리시스템즈 -->
                <div class="py-5">
                    <div class="iw-1" :class="{ 'd-flex': !isMobileDevice }"
                        style="border-bottom: 2px solid #7F1B27; border-top: 2px solid #7F1B27;"
                        :style="!isMobileDevice ? 'align-items: center; gap: 40px;' : ''">
                        <div :class="isMobileDevice ? 'text-center py-3' : 'iw-2 px-3'">
                            <img src="@/assets/img/s_info/s_info_logo.png"
                                :style="isMobileDevice ? 'max-width: 250px; width: 100%;' : 'max-width: 400px; width: 100%;'">
                        </div>
                        <div :class="isMobileDevice ? 'px-3 pb-3' : 'iw-2 px-3'" style="line-height:200%">
                            <div v-if="!isMobileDevice" style="height:20px"></div>
                            <p class="fkr-set2 fs-13 fc-w10"><strong>(주)엠쓰리시스템즈</strong>는</p>
                            <p class="fkr-set2 fs-09"><strong>Manufactured Modular via Meta-X Systems</strong> 입니다.</p>
                            <p class="fkr-set2 fs-09">첨단 BIM통합형 DfMA 기술을 보유한 모듈러건축 통합플랫폼 서비스 기업입니다.</p>
                            <p class="fkr-set2 fs-09">ESG(Environmental, Social and Governance)기업경영 윤리기반으로, 소중한 사람들과
                                함께하는
                                건축공간을 빠르고 정확하고 편리하게 제공합니다.</p>
                            <p class="fkr-set2 fs-09">연구진의 지난 20여년 간의 BIM 연구개발 경험 및 전문성으로 프리미엄 모듈러 건축물을 만드는 신뢰할 수 있는
                                기업으로
                                발전하겠습니다.</p>
                            <div v-if="!isMobileDevice" style="height:20px"></div>
                        </div>
                    </div>
                </div>
                <!-- Characteristics -->
                <!-- <div class="py-3">
                    <div class="x_div_center"><span class="fen-set3 fs-16"><strong>
                                <h2>Characteristics</h2>
                            </strong></span></div>
                    <div class="x_div_center py-3"><span class="fkr-set2 fs-10">M3는 속도, 품질, 기술, 친환경 건축으로 앞서 갑니다.</span>
                    </div>
                    <div class="iw-1">
                        <div class="iw-3 d-flex" style="align-items:start;">
                            <div class="iw-3 px-1 py-2">
                                <div class="text-center"><img src="@/assets/img/s_info/info2.jpg" width="95%"></div>
                                <div class="text-center py-2">
                                    <div class="py-2 fen-set3 fs-13">
                                        <h5>Speed</h5>
                                    </div>
                                    <div class="px-3 fkr-set2 fs-09">고객의 취향과 요구사항에 부합된 최적화된 디자인을 하고 빠르게 실현합니다.</div>
                                </div>
                            </div>
                            <div class="iw-3 px-1 py-2">
                                <div class="text-center"><img src="@/assets/img/s_info/info3.png" width="95%"></div>
                                <div class="text-center py-2">
                                    <div class="py-2 fen-set3 fs-13">
                                        <h5>Higher Quality</h5>
                                    </div>
                                    <div class="px-3 fkr-set2 fs-09">디지털화와 제조업화를 통해 가격,가치, 품질 좋은 건물을 보다 빠르게 선사합니다.</div>
                                </div>
                            </div>
                        </div>
                        <div class="iw-3 d-flex" style="align-items:start;">
                            <div class="iw-3 px-1 py-2">
                                <div class="text-center"><img src="@/assets/img/s_info/info4.jpg" width="95%"></div>
                                <div class="text-center py-2">
                                    <div class="py-2 fen-set3 fs-13">
                                        <h5>BIM + Platform</h5>
                                    </div>
                                    <div class="px-3 fkr-set2 fs-09">축적된 BIM 기술과 DfMA 플랫폼으로 빠르고 품질 좋은 건축서비스를 제공합니다.
                                    </div>
                                </div>
                            </div>
                            <div class="iw-3 px-1 py-2">
                                <div class="text-center"><img src="@/assets/img/s_info/info5.jpg" width="95%"></div>
                                <div class="text-center py-2">
                                    <div class="py-2 fen-set3 fs-13">
                                        <h5>Eco-Friendly</h5>
                                    </div>
                                    <div class="px-3 fkr-set2 fs-09">모듈러 공법으로 폐자재를 줄이고 친환경 설계로, 냉난방비를 효과적으로 절감합니다.</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div style="height:50px"></div> -->

                <div class="py-3" style="border-bottom:1px solid #e9e9e9; overflow-x:auto">
                    <div class="x_div_center"><span class="fen-set3 fs-16"><strong>
                                <h2>Facilities</h2>
                            </strong></span></div>
                    <div class="x_div_center py-3"><span class="fkr-set2 fs-10">당신의 꿈, 당신의 미래를 만드는 곳 입니다.</span></div>
                    <div class="iw-1">
                        <div class="iw-5 px-3 py-2">
                            <!-- <div class="w-100" data-toggle="modal" data-target="#v-s1"><img
                                    src="@/assets/img/s_info/s_info_m1.jpg" width="100%" height="250"> -->
                            <div class="w-100" data-toggle="modal" data-target="#v-s1"><img
                                    src="@/assets/img/s_info/s_info_m1_ver251209.jpg" width="100%" height="250">
                                <!-- <div class="x_div_center py-2 fkr-set1 fs-10">본사</div> -->
                                <div class="x_div_center py-2 fkr-set1 fs-10">기흥 오피스</div>
                            </div>
                        </div>
                        <div class="iw-5 px-3 py-2">
                            <!-- <div class="w-100" data-toggle="modal" data-target="#v-s2"><img
                                    src="@/assets/img/s_info/s_info_m2.png" width="100%" height="250"> -->
                            <div class="w-100" data-toggle="modal" data-target="#v-s2"><img
                                    src="@/assets/img/s_info/s_info_m2_ver251209.jpg" width="100%" height="250">
                                <!-- <div class="x_div_center py-2 fkr-set1 fs-10">부설연구소</div> -->
                                <div class="x_div_center py-2 fkr-set1 fs-10">서울 오피스</div>
                            </div>
                        </div>
                        <div class="iw-5 px-3 py-2">
                            <!-- <div class="w-100" data-toggle="modal" data-target="#v-s3"><img
                                    src="@/assets/img/s_info/s_info_m3.jpg" width="100%" height="250"> -->
                            <div class="w-100" data-toggle="modal" data-target="#v-s3"><img
                                    src="@/assets/img/s_info/s_info_m3_ver251209.jpg" width="100%" height="250">
                                <!-- <div class="x_div_center py-2 fkr-set1 fs-10">모듈러 공장</div> -->
                                <div class="x_div_center py-2 fkr-set1 fs-10">이천 공장</div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 본사 -->
                <div id="v-s1" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
                    aria-hidden="true" style="z-index:100000001; top:7%">
                    <div class="modal-dialog modal-lg" role="document">
                        <div class="modal-content">

                            <div class="w-100">
                                <div class="x_div_center w-100"
                                    style="background-color:#333; border-top-left-radius:4px; border-top-right-radius:4px">
                                    <!-- <div class="w-100 p-3 ps-4"><span class="fkr-set1 fs-11 fc-w8">본사</span></div> -->
                                    <div class="w-100 p-3 ps-4"><span class="fkr-set1 fs-11 fc-w8">기흥 오피스</span></div>
                                    <div class="text-end pe-4" style="width:100px"><a href="#@" data-dismiss="modal"><i
                                                class="fa-solid fa-xmark fs-15 fc-w1"></i></a></div>
                                </div>

                                <!-- <div><img src="@/assets/img/s_info/s_info_m1.jpg" width="100%"
                                        style="border-bottom-left-radius:5px; border-bottom-right-radius:5px"></div> -->
                                <div><img src="@/assets/img/s_info/s_info_m1_ver251209.jpg" width="100%"
                                        style="border-bottom-left-radius:5px; border-bottom-right-radius:5px"></div>

                            </div>

                        </div>
                    </div>
                </div>

                <!-- 부설연구소 -->
                <div id="v-s2" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
                    aria-hidden="true" style="z-index:100000001; top:7%">
                    <div class="modal-dialog modal-lg" role="document">
                        <div class="modal-content">

                            <div class="w-100">
                                <div class="x_div_center w-100"
                                    style="background-color:#333; border-top-left-radius:4px; border-top-right-radius:4px">
                                    <!-- <div class="w-100 p-3 ps-4"><span class="fkr-set1 fs-11 fc-w8">부설연구소</span></div> -->
                                    <div class="w-100 p-3 ps-4"><span class="fkr-set1 fs-11 fc-w8">서울 오피스</span></div>
                                    <div class="text-end pe-4" style="width:100px"><a href="#@" data-dismiss="modal"><i
                                                class="fa-solid fa-xmark fs-15 fc-w1"></i></a></div>
                                </div>

                                <!-- <div><img src="@/assets/img/s_info/s_info_m2.png" width="100%"
                                        style="border-bottom-left-radius:5px; border-bottom-right-radius:5px"></div> -->
                                <div><img src="@/assets/img/s_info/s_info_m2_ver251209.jpg" width="100%"
                                        style="border-bottom-left-radius:5px; border-bottom-right-radius:5px"></div>

                            </div>

                        </div>
                    </div>
                </div>

                <!-- 모듈러 공장 -->
                <div id="v-s3" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
                    aria-hidden="true" style="z-index:100000001; top:7%">
                    <div class="modal-dialog modal-lg" role="document">
                        <div class="modal-content">

                            <div class="w-100">
                                <div class="x_div_center w-100"
                                    style="background-color:#333; border-top-left-radius:4px; border-top-right-radius:4px">
                                    <!-- <div class="w-100 p-3 ps-4"><span class="fkr-set1 fs-11 fc-w8">모듈러 공장</span></div> -->
                                    <div class="w-100 p-3 ps-4"><span class="fkr-set1 fs-11 fc-w8">이천 공장</span></div>
                                    <div class="text-end pe-4" style="width:100px"><a href="#@" data-dismiss="modal"><i
                                                class="fa-solid fa-xmark fs-15 fc-w1"></i></a></div>
                                </div>

                                <!-- <div><img src="@/assets/img/s_info/s_info_m3.jpg" width="100%"
                                        style="border-bottom-left-radius:5px; border-bottom-right-radius:5px"></div> -->
                                <div><img src="@/assets/img/s_info/s_info_m3_ver251209.jpg" width="100%"
                                        style="border-bottom-left-radius:5px; border-bottom-right-radius:5px"></div>

                            </div>

                        </div>
                    </div>
                </div>

                <!-- <MenuFooter /> -->
            </div>
        </div>
    </div>
</template>

<script>
import MenuFooter from '@/components/MenuFooter.vue'
export default {
    name: 'MenuIntroduction',
    components: {
        MenuFooter
    },
    computed: {
        isMobileDevice() {
            return window.innerWidth <= 1024
        }
    }
}
</script>